import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons';

import ClickableIcon from 'components/clickable_icon';
import Confirmation from './attachment_deletion_confirmation';
import api from 'components/attachments/api';

import type { Attachment, Task } from 'bundles/apex/tasks/types';

interface Props {
  attachment: Attachment;
  attachmentsPath: string;
  canDeleteAttachments?: boolean;
  forUserId: number;
  task: Task;
  onDeleteAttachment: (task: Task, attachment: Attachment) => void;
}

export default function AttachmentsSection({
  attachment,
  attachmentsPath,
  canDeleteAttachments,
  forUserId,
  task,
  onDeleteAttachment,
}: Props) {
  const [showConfirmation, setShowConfirmation] = useState(false);

  function confirmDeletion(event: React.MouseEvent) {
    event.stopPropagation();
    setShowConfirmation(true);
  }

  async function deleteAttachment() {
    await api.deleteAttachment(attachmentsPath, attachment);
    onDeleteAttachment(task, attachment);
  }

  return <>
    <div
      className="d-flex align-items-center task-sidebar-modal__attachment p-3 ds-rounded"
      key={attachment.id}
      onClick={() => window.open(attachment.url)}
    >
      <div className="attachment-icon ds-rounded text-muted mr-3">
        <FontAwesomeIcon className="p-3" icon={faFileLines} />
      </div>
      <span className="flex-1 text-truncate">
        {attachment.displayName}
      </span>
      {(canDeleteAttachments || forUserId === attachment.uploadedById) &&
        <ClickableIcon
          className="attachment-delete-icon text-muted"
          icon={faTrashCan}
          onClick={confirmDeletion}
        />
      }
    </div>

    <Confirmation
      show={showConfirmation}
      onDelete={deleteAttachment}
      onHide={() => setShowConfirmation(false)}
    />
  </>;
}
